<template>
  <div class="offeringlist__wrapper">
    <span v-if="!isSingleSellerMarketPlace" class="buy_from">Buy from:</span>
    <div class="offeringlist__offeringsContainer">
      <div
        v-for='(offering, index) in orderedOfferings'
        :key="offering.id"
        class="offeringlist__offeringline"
        v-show="(displayAllOfferings || index < 3)"
      >
        <span
          v-if="offering.owner && offering.owner.image && !isSingleSellerMarketPlace"
          class="offeringlist__orgImageContainer"
        >
          <router-link
            :to="`/o/${offering.owner.slug}`"
          >
            <img
              class="offeringlist__orgImage"
              :src="offering.owner.image"
              alt="logo"
            >
          </router-link>
        </span>
        <div
          class="offeringlist__offering"
        >
          <div>
            <span>
              {{ offering.name }}
            </span>
            <br v-if="offering.owner.delivery_note && offering.owner.delivery_note.length" />
            <span
            v-if="offering.owner.delivery_note && offering.owner.delivery_note.length"
            class="offeringlist__delivery_note"
            >({{ offering.owner.delivery_note }})</span>
          </div>
          <div class="offeringlist__offering__right">
            <div class="offeringlist__offeringPrice">
              <div class="offeringlist__offeringPrice--discount">
                <span
                  v-if="offering.compare_at_price > offering.price"
                  class="offeringlist__offeringPrice--old"
                  >
                  {{ offering.currency === 'GBP' ? '£' : offering.currency }}
                  {{ getPrice(offering.compare_at_price, offering.currency) }}
                </span>
                <span
                  v-if="offering.compare_at_price > offering.price"
                  class="discountPercentage"
                >
                  {{ calculateDiscount(offering, offering.currency) }}
                </span>
              </div>
              <span class="offeringlist__offeringPrice--current">
                <b>{{ offering.currency === 'GBP' ? '£' : offering.currency }}{{ getPrice(offering.price, offering.currency) }}</b>
              </span>
            </div>
            <div class="addToCartContainer">
              <button
                class="addToCart"
                v-if="itemData.item_type !== 'article' && itemData.item_type !== 'post'"
                @click.stop="$emit('addItemToCart', {...itemData, offering: offering})"
                :disabled="offering.available_quantity <= 0 || categoryDisabled"
              >
                {{ offering.available_quantity > 0 || !categoryDisabled ? 'Add to cart' : 'Out of stock' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <span
        v-if="!displayAllOfferings && orderedOfferings.length > 3"
        @click.stop="displayAllOfferings = true"
        style="cursor:pointer; text-decoration: underline; padding-bottom: 10px;"
      >
        Show More...
      </span>
    </div>
  </div>
</template>

<script>
import currencyList from '@/assets/currencyList.json'
import _ from 'lodash'

export default {
  name: 'OfferingList',
  data () {
    return {
      currencyList: currencyList,
      displayAllOfferings: false
    }
  },
  props: {
    itemData: {
      type: Object,
      required: true,
      default: () => {}
    },
    // offeringList: {
    //   Type: Array,
    //   required: true,
    //   default: []
    // },
    isSingleSellerMarketPlace: {
      type: Boolean,
      required: false,
      default: false
    // },
    // displayAllOfferings: {
    //   type: Boolean,
    //   required: false,
    //   default: false
    }
  },
  methods: {
    calculateDiscount (offering, currency) {
      if (offering.compare_at_price <= offering.price) {
        return ''
      }
      const originalPrice = offering.compare_at_price / Math.pow(10, currencyList[currency]['fractionSize'])
      const newPrice = offering.price / Math.pow(10, currencyList[currency]['fractionSize'])
      const discountPercentage =
        (1 -
          parseFloat(newPrice) / parseFloat(originalPrice)
        ) * 100
      return '-' + parseInt(discountPercentage) + '% '
    },
    getPrice (price, currency) {
      // Converts a price from minor currency units to major ones
      return price / Math.pow(10, currencyList[currency]['fractionSize'])
    }
  },
  computed: {
    orderedOfferings () {
      return _.orderBy(this.itemData.offerings, [function (result) { return result.available_quantity > 0 }, 'price'], ['desc', 'asc'])
    },
    categoryDisabled () {
      const disabledCollections = ['vk_icecream']
      if (disabledCollections.length === 0 || this.itemData.collections.length === 0) { return false }
      return disabledCollections.some((disCollection) => {
        return this.itemData.collections.includes(disCollection)
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.offeringlist
  &__wrapper
    margin-top 10px
    min-width: 56%
  &__offeringsContainer
    display flex
    flex-direction column
    align-items start
    margin-top 10px
    min-width 50%
    max-height 500px
    overflow-y auto
  &__offeringline
    display flex
    align-items center
    width: 100%;
  &__offering
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    background-color #fdfaec
    border 1px solid #f5d74b
    border-radius 4px
    margin 5px 0 0 5px;
    padding 8px 8px
    font-size 14px
    &__right {
      display: flex;
    }
  &__orgImage
    display: flex;
    height: 100%;
    max-width: 75px;
    max-height 35px
    margin: auto;
    // padding-right: 10px
    @media screen and (max-width: 450px) {
      max-width: 50px;
    }
  &__orgImageContainer
    width: 75px;
    @media screen and (max-width: 450px) {
      width: 50px;
      // margin-right: 5px;
    }
  &__offeringPrice
    margin-left 5px
    // margin-right 5px
    white-space nowrap
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-end;
    justify-content: center;
    &--discount {
      font-size: 11px;
      // display: flex;
      @media screen and (max-width: 450px) {
        display: flex;
        flex-direction: column;
      }
    }
    &--current {
      font-weight bold
      font-size: 18px
    }
    &--old
      text-decoration line-through
  &__delivery_note {
    text-decoration: underline;
    font-style: italic;
  }
.discountPercentage
  color: #24A068;
  font-weight bold
  margin 0 0 0 5px
.addToCartContainer {
  display: flex;
  align-items: center;
}
.addToCart
  height: fit-content;
  min-width: 100px;
  margin-left 5px
  background #f5d74b
  border none
  outline none
  color #94822b
  font-size 14px
  padding 8px 8px
  border-radius 6px
  font-weight bold
  cursor pointer
  &[disabled]
    cursor default
    background #dc6861
    color: #9f241c

.buy_from
  padding-top 20px
  padding-bottom 10px
  font-weight 600
</style>
